import { formatPics, filterParams } from '@/common/utils/format'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

import { get } from 'lodash-es'

// 对后端接口下发的数据做格式转换
export function revert (data = {}) {
  const cnpj = get(data, 'bizGlobal.docInfo.cnpj')
  if (!cnpj) return {}
  return {
    licensePics: formatPics(cnpj.licensePics),
    id: cnpj.id,
    files: formatPics(cnpj.files)
  }
}

export function submitFormat (cnpjInfo) {
  return {
    params: JSON.stringify({
      source: 'contractor',
      queryId: this.$route.params.id,
      bizGlobal: {
        ...cnpjInfo.bizGlobal,
        country: country
      }
    })
  }
}


export default {
  revert,
  submitFormat
}
